import type { FilterConsistencyState } from '../engine/filterGroupConsistency';

// Filter state is shared across pages so selections carry over as the user
// navigates. State is keyed by scope: the default scope is shared by all pages,
// while a page that should be isolated (e.g. posting discovery) passes its own
// scope key so it neither inherits from nor leaks into the shared scope.
export const DEFAULT_FILTER_SCOPE = 'global';

const sharedFilterStates = new Map<string, FilterConsistencyState>();

export const getSharedFilterState = (
  scopeKey: string = DEFAULT_FILTER_SCOPE
): FilterConsistencyState | null => sharedFilterStates.get(scopeKey) ?? null;

export const setSharedFilterState = (
  next: FilterConsistencyState,
  scopeKey: string = DEFAULT_FILTER_SCOPE
): void => {
  if (sharedFilterStates.get(scopeKey) === next) return;
  sharedFilterStates.set(scopeKey, next);
};

/**Test-only: drop all shared state */
export const __resetSharedFilterStateForTests = (): void => {
  sharedFilterStates.clear();
};
